<template>
	<transition name="fade" mode="out-in">
		<loader v-if="loading"></loader>
		<div v-else class="quote-tool">
			<!-- Header may go into the QuoteTool.master, but have popped the markup in here for now - RM -->
			<header class="quote-tool__header">
				<div class="container top-container">
					<div class="row flex-row align-items-start align-items-md-center flex-nowrap">
						<div class="col col-sm-auto">
							<a class="main-logo" href="/">
								<img src="/media/ukieam2m/sfb-logo-high-res-rgb.jpg" height="90" width="178" class="img-fluid" alt="Source for Business - Logo">
							</a>
						</div>
						<div class="top-container__tagline col-sm-7">
							<span class="s4b__strapline d-none d-lg-inline-block">{{ labels.headerTagLine }}</span>
						</div>
						<div class="col col-xl-auto d-flex justify-content-end">
							<div class="top-container__right ">
								<span class="top-container__right-heading">{{ labels.headerHelpIntro }}</span>
								<span class="top-container__right-call-us"><a :href="`tel:${labels.headerPhoneNumberNumber}`" :title="labels.headerPhoneNumber">{{ labels.headerPhoneNumber }}</a></span>
								<span class="top-container__right-opening-times">{{ labels.headerOpeningTimes }}</span>
							</div>
						</div>
					</div>
				</div>
			</header>
			<div v-if="currentStepComponent == 'IntroStep'">
				<step-header :nav="false"></step-header>
				<intro-step></intro-step>
			</div>
			<div v-else>

				<step-header></step-header>
				<transition name="fade" mode="out-in">
					<component :is="currentStepComponent"></component>
				</transition>
			</div>
		</div>
	</transition>
</template>

<script>
	import Loader from './Loader.vue';
	import { mapGetters, mapActions, mapState } from 'vuex';

	import CompleteStep from './steps/CompleteStep.vue';
	import DropoutCompleteStep from './steps/DropoutCompleteStep.vue';
	import InformationStep from './steps/InformationStep.vue';
	import IntroStep from './steps/IntroStep.vue';
	import PaymentStep from './steps/PaymentStep.vue';
	import QuoteStep from './steps/QuoteStep.vue';
	import WaterConsumptionStep from './steps/WaterConsumptionStep.vue';

	import StepHeader from './StepHeader.vue';
	import $ from 'jquery';

	export default {
		components: {
			IntroStep,
			CompleteStep,
			DropoutCompleteStep,
			InformationStep,
			PaymentStep,
			QuoteStep,
			WaterConsumptionStep,
			StepHeader,
			Loader,
		},

		data() {
			return {
				loading: true,
			}
		},

		mounted() {
			this.getCopy()
				.then(() => {
					var field = "confirmation";
					var _status = window.location.href.indexOf('?' + field + '=');

					if (_status != -1) {
						this.toggleConfirmationStep();
					}
				})
				.catch(error => {
					console.error(error);
				}).finally(() => {
					this.loading = false;
				})
		},

		computed: {
			...mapGetters('stepProgress', [
				'currentStepComponent'
			]),

			...mapState('microcopy', [
				'labels',
			])
		},

		methods: {
			...mapActions('stepProgress', {
				toggleConfirmationStep: 'toggleConfirmationStep',
			}),

			...mapActions('microcopy', {
				getCopy: 'getCopy',
			})
		},

		watch: {
			currentStepComponent() {
				$('html, body').animate({
					scrollTop: $('.quoteTool__header').offset().top
				}, 500);
			}
		}
	}
</script>

<style>
	.fade-enter-active, .fade-leave-active {
		transition: opacity .5s;
	}

	.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
		opacity: 0;
	}
</style>
